import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconMarriottRectangle = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props} ref={ref}>
    <g clipPath="url(#clip0_5098_130927)">
      <rect x="0.800049" width="24" height="24" rx="6" fill="#34E0A1" />
      <path
        d="M19.8667 23.9873H5.7333C3.01681 23.9873 0.800049 21.7744 0.800049 19.0497V4.94044C0.800049 2.2286 3.01681 0.015625 5.7333 0.015625H19.8667C22.596 0.015625 24.8 2.2286 24.8 4.94044V19.0497C24.8128 21.7744 22.596 23.9873 19.8667 23.9873Z"
        fill="#C6003D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0037 16.0909C22.6663 12.0536 20.4378 5.429 14.6785 4.5L20.0037 16.0909ZM18.2391 18.1298C18.0944 18.6999 17.5735 18.9662 17.313 19.0848L10.7145 4.82266C11.2608 4.44598 11.55 4.4807 11.9794 4.53225L11.9878 4.53326L18.2391 18.1298ZM10.6454 9.95572L10.6454 9.95572C10.9987 10.7025 11.3666 11.4802 10.9247 12.3288C10.6642 13.4575 9.59337 14.372 8.46468 14.5543C7.2781 14.6614 6.17833 14.4617 5.28116 13.7469C4.67339 10.4881 6.00469 7.47246 8.58044 5.67522L10.3458 9.26969C10.428 9.49619 10.536 9.72447 10.6454 9.95572ZM6.60369 16.7088C8.42698 19.9444 14.2442 21.2381 14.823 19.2672L11.7552 12.4284C11.6974 14.8508 9.0058 16.975 6.60369 16.7088Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5098_130927">
        <rect x="0.800049" width="24" height="24" rx="6" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const IconMarriottRectangle = forwardRef(_IconMarriottRectangle)
